module.exports = function getResource(label) {
    const resources = {
        closeAccount: 'Close Account',
        ok: 'OK'
    };
    return resources[label];
};
